import React from 'react'
import { CLOSING_PRICE, CLOSING_VALUE, CURRENT_PRICE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE, HOLDING_PERCENTAGE } from './HoldingsTable/HoldingsTable';
import { dollarToString } from '../../../../lib/currency-utils';

const HoldingsTableData = ({ header, item }) => {
    const renderTableData = () => {
        const color = item > 0 ? "#008040" : "#F00"

        switch(header) {
            case CLOSING_PRICE.label:
                return <div>{dollarToString(item)}</div>;
            case CLOSING_VALUE.label:
                return <div>{dollarToString(item)}</div>;
            case HOLDING_PERCENTAGE.label:
                return <div>{`${Number(item).toFixed(2)} %`}</div>;
            case CURRENT_PRICE.label:
                return <div>{dollarToString(item)}</div>;
            case DAILY_GAIN_DOLLAR.label:
                return <div style={{ color }}>{dollarToString(item)}</div>;
            case DAILY_GAIN_PERCENTAGE.label:
                return <div style={{ color }}>{`${Number(item).toFixed(2)} %`}</div>;
            default:
                return <div>{item}</div>
        }
    }

    return (
        <React.Fragment>
            {renderTableData()}
        </React.Fragment>
    )
}

export default HoldingsTableData